import { INVOICE_NEXT, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";
import * as actions from "../../../../Config/ApiUrl";

export const Schema = {
    components: {  },

    data() {

        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            Endpoint: INVOICE_NEXT,
            tableId: "invoice-next-table",
            formId: "invoice-next-form",
            rowData: {},
            tableColumns: [
                {
                    title: "Student ID",
                    type: "custom-html",
                    key: "lead",
                    modifier: (value, row) => {
                        
                        return value.student_id;
                    },
                },
                {
                    title: "Student Name",
                    type: "custom-html",
                    key: "lead",
                    modifier: (value, row) => {
                        
                        return value.full_name;
                    },
                },
                {
                    title: "Teacher",
                    type: "custom-html",
                    key: "teacher_comment_list",
                    modifier: (value, row) => {
                        
                        const list = value || [];

                        const hasStatus2 = list.some(item => item.status === 2);

                        return hasStatus2 ? 'Move' : 'Continue';
                    },
                },
                {
                    title: "Apps",
                    type: "custom-html",
                    key: "student_id",
                    modifier: (value, row) => {
                        
                        
                        var buttonAction = `<button 
                                class="btn btn-success " 
                                data-bs-toggle="tooltip" 
                                title="Edit"
                                style="border-radius: 15px !important; padding: 0.4rem 0.5rem;margin-right: 3px;"
                                onclick="window.HandleDetailApps(${row.lead_id})"
                            >
                                <i class="fa fa-eye"></i>
                            </button>`;
                        return buttonAction;
                    },
                },
                {
                    title: "Academic Advisor",
                    type: "custom-html",
                    key: "student_id",
                    modifier: (value, row) => {
                        var buttonAction = `
                            <div class="dropdown">
                                <button 
                                    class="btn btn-success dropdown-toggle"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                    style="border-radius: 15px; padding: 0.4rem 0.6rem;"
                                >
                                    &nbsp;&nbsp; <i class="fas fa-caret-down"></i>&nbsp;&nbsp;
                                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" href="javascript:void(0)" 
                                            onclick="window.HandleContinueAA(${row.id})">
                                            Continue
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="javascript:void(0)" 
                                            onclick="window.HandleMoveAA(${row.id})">
                                            Move
                                        </a>
                                    </li>
                                </ul>
                            </div>`;
                        return buttonAction;
                    },
                },
                {
                    title: "Note",
                    type: "custom-html",
                    key: "id",
                    modifier: (value, row) => {
                        return "-";
                    },
                },
                {
                    title: "Approval Supervisor",
                    type: "custom-html",
                    key: "id",
                    modifier: (value, row) => {
                        return "-";
                    },
                },
                {
                    title: "Invoice Status",
                    type: "custom-html",
                    key: "id",
                    modifier: (value, row) => {
                        return "-";
                    },
                },
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "InvoiceNextTable",
                url: INVOICE_NEXT,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    // {
                    // 	title: this.$t("edit"),
                    // 	icon: "eye",
                    // 	type: "none",
                    // 	component: "app-add-modal",
                    // 	modalId: "CONTINUELIST-form",
                    // },
                ],
                filters: [
                    
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {
        isPifDisabled(rowData) {
            if (rowData.status === "inactive") return true;
            else if (rowData.status === "not_interested") return true;
            else if (rowData.status === "invalid") return true;
            else return false;
        },
    },
};
